
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const ChurchSteepleCommonIssues = () => {
  const issues = [
    {
      issue: "Water Infiltration",
      prevalence: "87% of damaged steeples",
      cause: "Complex joint architecture, deteriorated flashing, Eastern NC's high annual rainfall (46-52 inches) documented by NC State Climate Office",
      solution: "Custom-fabricated stainless steel flashing systems, NRCA-certified membrane integration, multi-layer sealant protocol following Building Science Corporation moisture control standards"
    },
    {
      issue: "Structural Deterioration",
      prevalence: "73% of steeples 50+ years old",
      cause: "Moisture damage to wooden elements, insect infestation, original construction limitations predating modern ICC building codes",
      solution: "Strategic steel reinforcement, pressure-treated replacement timber, epoxy consolidation of salvageable elements following APTI preservation techniques"
    },
    {
      issue: "Hurricane Damage",
      prevalence: "42% of Eastern NC steeples",
      cause: "Wind forces amplified at steeple height, inadequate original anchoring, projectile impacts documented in NOAA Storm Events Database",
      solution: "140+ mph wind-rated connection systems, integrated wind load distribution framework, impact-resistant exterior materials"
    },
    {
      issue: "Lightning Damage",
      prevalence: "23% of steeples",
      cause: "Height attraction, inadequate or outdated protection systems, NC's high thunderstorm frequency per NOAA climate data",
      solution: "UL-certified lightning protection systems compliant with NFPA 780 standards, full-building pathway integration, decoratively compatible conductor installation per Lightning Protection Institute guidelines"
    },
    {
      issue: "Ornamental Degradation",
      prevalence: "91% of steeples 75+ years old",
      cause: "UV exposure, thermal cycling, original material limitations, pollution exposure affecting historical finishes",
      solution: "Historical material matching with modern performance enhancements following National Trust for Historic Preservation protocols, custom fabrication, UV-stabilized finishing systems from premium manufacturers"
    }
  ];

  return (
    <section id="common-issues" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold mb-4 text-center">Church Steeple Issues Common in Eastern North Carolina</h2>
        
        <p className="text-center mb-12">Based on our extensive experience restoring church steeples and data from the <a href="https://www.nrca.net/" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">National Roofing Contractors Association</a>, <a href="https://climate.ncsu.edu/" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">North Carolina State Climate Office</a>, and <a href="https://www.csiresources.org/" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">Construction Specifications Institute</a>, these are the most common church steeple problems in Eastern North Carolina:</p>
        
        <div className="overflow-x-auto mb-8">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-brand-charcoal-gray text-white">
                <th className="p-4 text-left">Issue</th>
                <th className="p-4 text-left">Prevalence</th>
                <th className="p-4 text-left">Cause</th>
                <th className="p-4 text-left">Trophy-Quality Solution</th>
              </tr>
            </thead>
            <tbody>
              {issues.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="p-4 border-b"><strong>{item.issue}</strong></td>
                  <td className="p-4 border-b">{item.prevalence}</td>
                  <td className="p-4 border-b">{item.cause}</td>
                  <td className="p-4 border-b">{item.solution}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="bg-brand-carolina-blue/10 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold mb-3">Is Your Church Steeple Showing These Warning Signs?</h3>
          <p className="mb-6 text-lg">Request our free 27-point Church Steeple Inspection to identify potential issues before they become costly emergencies.</p>
          <Link to="/contact">
            <Button className="bg-brand-trophy-gold hover:bg-brand-trophy-gold/90 text-white font-bold px-8 py-3 text-lg">
              Schedule Free Inspection
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ChurchSteepleCommonIssues;
